import { versions } from "@/mocks/home";

export default function Versions() {
  return (
    <section id="versions" className="scroll-mt-20 bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="mb-10 max-w-3xl">
          <span className="font-label text-xs tracking-widest text-accent-400">VERSIONS</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            版本对比：高清在线 / 免费在线 / 完整版
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
            同一个主题在页面上可能会出现几种不同的说法：高清在线、免费在线、完整版与无删减。它们并不是互相替代的关系，而是分别回答了「清不清晰」「要不要额外步骤」「内容全不全」这三个问题。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {versions.map((version) => (
            <article
              key={version.id}
              className={`flex flex-col overflow-hidden rounded-lg border transition-colors ${
                version.highlight
                  ? "border-accent-500/60 bg-foreground-900"
                  : "border-foreground-700/50 bg-foreground-900/60"
              }`}
            >
              <div className="relative h-56 w-full md:h-64">
                <img
                  src={version.image}
                  alt={`${version.name}版本示意图`}
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 to-transparent"></div>
                {version.highlight && (
                  <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-label text-foreground-950">
                    更常用
                  </span>
                )}
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-xl font-bold text-background-50">{version.name}</h3>
                  <p className="text-xs font-label text-background-300">{version.subtitle}</p>
                </div>
              </div>

              <ul className="flex flex-1 flex-col gap-3 p-6">
                {version.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-2 text-sm text-background-100">
                    <i className={`ri-check-line text-base ${version.highlight ? "text-accent-400" : "text-accent-500"}`}></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs leading-relaxed text-background-400">
          说明：以上差别主要影响观看体验，具体以页面当前展示的线路与版本为准。
        </p>
      </div>
    </section>
  );
}